module.exports = __webpack_public_path__ + "img/favicon.67e4d471.png";